export const API_BASE_URL: string = process.env.REACT_APP_API_BASE_URL || "";
export const DEFAULT_USER_POOL_ID: string = process.env.REACT_APP_DEFAULT_USER_POOL_ID || "";
export const DEFAULT_TENANT: string = process.env.REACT_APP_DEFAULT_TENANT || "";
export const DEFAULT_CLIENT_ID: string = process.env.REACT_APP_DEFAULT_CLIENT_ID || "";
export const DEFAULT_REDIRECT_URI: string = process.env.REACT_APP_DEFAULT_REDIRECT_URI || "";
export const DEFAULT_S3_URI: string = process.env.REACT_APP_DEFAULT_S3_URI || "";
export const REACT_APP_API_MANAGEMENT_URL: string = process.env.REACT_APP_API_MANAGEMENT_URL || "";
export const DEFAULT_COUNTDOWN_TIME: string = process.env.REACT_APP_DEFAULT_COUNTDOWN_TIME || "5";